import { atom } from "recoil";

export const updateSourceDrawerState = atom({
  key: "updateSourceDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
